import { Star, Quote } from "lucide-react";
import REVIEWS from "@/data/reviews";
import { useCity } from "@/context/LocationContext";

const Stars = ({ n }) => (
    <div className="flex items-center gap-0.5">
        {Array.from({ length: 5 }).map((_, i) => (
            <Star
                key={i}
                className={`h-4 w-4 ${i < n ? "fill-[#FFB800] text-[#FFB800]" : "text-zinc-300"}`}
                strokeWidth={1.5}
            />
        ))}
    </div>
);

const ReviewsSection = () => {
    const { city, postal } = useCity();
    const cityLabel = city ? `${city}${postal ? " " + postal : ""}` : "";
    const avg = (REVIEWS.reduce((s, r) => s + r.rating, 0) / REVIEWS.length).toFixed(1);
    return (
        <section className="bg-[#FAFAFA] border-t border-black/10 py-16 lg:py-24" data-testid="reviews-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-12">
                    <div className="lg:col-span-7">
                        <div className="text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 mb-4">
                            ◉ Avis clients
                        </div>
                        <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[0.95]">
                            Ce que disent<br /><span className="text-[#E63946]">nos clients.</span>
                        </h2>
                        <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed max-w-xl">
                            Retours d'interventions récentes d'Atelier Beauchamp dans la commune.
                            Chaque avis reflète une prestation réelle : ouverture, dépannage, remplacement ou pose.
                        </p>
                    </div>

                    <div className="lg:col-span-5 flex items-center gap-6">
                        <div className="font-display text-6xl sm:text-7xl font-bold tracking-tight leading-none">{avg}</div>
                        <div>
                            <Stars n={5} />
                            <div className="mt-2 text-sm text-zinc-700 font-medium">Note moyenne sur {REVIEWS.length} avis</div>
                            <div className="text-xs uppercase tracking-[0.18em] text-zinc-500 mt-1 font-semibold">100 % clients satisfaits</div>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {REVIEWS.map((r, i) => (
                        <article
                            key={i}
                            data-testid={`review-card-${i}`}
                            className="bg-white border border-black/10 p-6 sm:p-7 hover:-translate-y-1 hover:border-black transition-all duration-200 flex flex-col"
                        >
                            <div className="flex items-center justify-between">
                                <Stars n={r.rating} />
                                <span className="text-[10px] uppercase tracking-[0.18em] font-semibold text-zinc-500">{r.service}</span>
                            </div>
                            <Quote className="h-5 w-5 text-[#E63946] mt-5" strokeWidth={2.4} />
                            <p className="mt-3 text-sm sm:text-base text-zinc-700 leading-relaxed flex-1">« {r.text} »</p>
                            <div className="mt-6 pt-5 border-t border-black/10 flex items-center justify-between">
                                <div>
                                    <div className="font-display font-bold text-sm">{r.name}</div>
                                    {cityLabel && (
                                        <div className="text-[10px] uppercase tracking-[0.15em] text-zinc-500 mt-0.5">{cityLabel}</div>
                                    )}
                                </div>
                                <div className="text-[10px] uppercase tracking-[0.15em] text-zinc-400 font-semibold">{r.date}</div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ReviewsSection;
